module.exports = __webpack_public_path__ + "media/images/title_bg-0fe206568b4801dfee0f41b17197b7d7.png";